/**
 * Created by comoon on 7/28/15.
 */

var $ = require('jquery');
var _ = require('underscore');

var {randomTimeId} = require("./seed.js");

var _ajaxQueue = [];

var BLOCKING_CLASS = "is-blocking";

function post(url, data, option) {
    return communicate("post", url, data, option);
}

function query(url, data, option) {
    return communicate("get", url, data, option);
}

function jsonp(url, data, option) {
    return communicate("getJSON", url, data, option);
}

function communicate(method, url, data, option) {
    var options = _.extend({}, {global: true, catchAbort: false}, option);
    var global = options.global;

    var body = $("body");
    var path = body.data("path") || "";//can use cache to improve performance
    var blockerId = randomTimeId();

    if (global) {
        _ajaxQueue.push(blockerId);
        if (!body.hasClass(BLOCKING_CLASS)) {
            body.addClass(BLOCKING_CLASS);
            body.append(generateBlocker());
        }
    }

    var realUrl = url;

    if (!/^(http|ftp|ws)s?:\/\//.test(url)) {

        realUrl = path + url;
    }

    var jxhr = $[method](realUrl, data, null, options.type);
    var deferred = $.Deferred();

    jxhr.done(function (res) {
        if (res.code === 0) {
            deferred.resolve(res.data, res, jxhr);
        } else {
            if (_.isString(res)) {
                res = {code: 404, msg: "好像迷路了……", previous: res};
            }
            deferred.reject(res, jxhr);
            //TODO emit error
        }
    });

    jxhr.fail(function (res) {
        var status = res.status;
        res = {code: res.status, previous: res};
        switch (status) {
            case 504:
                res.msg = "连接超时，服务器无响应……";
                break;
            case 0:
                res.msg = "请求被取消……";
                break;
            default:
                res.msg = `发生错误了呢[${status}]……`;
                break;
        }
        deferred.reject(res, jxhr);
        if (status === 0 && !options.catchAbort) {
            // 当用户取消了请求，
            // 如果没有设置自动捕捉取消错误，则不发送错误信息
            return;
        }
        _.defer(function () {
            //TODO emit error
        });
    });

    jxhr.always(function () {
        var index = _ajaxQueue.indexOf(blockerId);
        if(index > -1){
            _ajaxQueue.splice(index, 1);
        }
        if (_ajaxQueue.length === 0) {
            body.find(".js-top-ajax-blocker").remove();
            body.removeClass(BLOCKING_CLASS);
        }
    });
    deferred.jxhr = jxhr;
    return deferred;
}

function generateBlocker() {
    return "<div class='ajax-blocker js-top-ajax-blocker'></div>";
}

module.exports = {
    query,
    post,
    jsonp
};


/** WEBPACK FOOTER **
 ** ./script/util/ajax.js
 **/